// extracted by mini-css-extract-plugin
export var buttonIcon = "gallery-module--buttonIcon--fdf2e";
export var buttons = "gallery-module--buttons--e8ac4";
export var carousel = "gallery-module--carousel--5f71e";
export var carouselButton = "gallery-module--carouselButton--aa20b";
export var dark = "gallery-module--dark--6c899";
export var gallery = "gallery-module--gallery--a22f2";
export var galleryCards = "gallery-module--galleryCards--99ae2";
export var galleryScrollBox = "gallery-module--galleryScrollBox--9c143";
export var headline = "gallery-module--headline--108e0";
export var introContent = "gallery-module--introContent--9fab9";
export var introText = "gallery-module--introText--f14da";
export var light = "gallery-module--light--01cdf";
export var next = "gallery-module--next--9371b";
export var previous = "gallery-module--previous--88b32";
export var show = "gallery-module--show--30994";
export var subhead = "gallery-module--subhead--548f7";